import MicroModal from 'micromodal';  // es6 module

/**
 * モーダルの初期化
 */
export const modal = {
  init: () => {
    MicroModal.init({
      openTrigger: 'data-modal-open',
      closeTrigger: 'data-modal-close',
      disableScroll: true,
      awaitCloseAnimation: true,
      onShow: (modalEl) => {
        if (modalEl.id === 'global-nav') {
          modalEl.classList.remove('is-closing');
          document.getElementById('header')?.classList.remove('is-closing');
        }
      },
      onClose: (modalEl) => {
        if (modalEl.id === 'global-nav') {
          modalEl.classList.add('is-closing');
          document.getElementById('header')?.classList.add('is-closing');
          // 閉じた時に内部スクロール位置を先頭に戻す
          // （モバイルで開き直した際に位置がズレるのを防ぐ）
          const resetScroll = () => {
            const scrollTargets = (modalEl as HTMLElement).querySelectorAll(
              '.global-nav__overlay, .global-nav__container, .global-nav__content, .modal__overlay, .modal__container'
            );
            scrollTargets.forEach((el) => {
              (el as HTMLElement).scrollTop = 0;
            });
          };
          resetScroll();
          // アニメーション終了後にもう一度リセット
          // （アニメーション中にスクロールが発生してしまった場合の保険）
          (modalEl as HTMLElement).addEventListener('animationend', resetScroll, {
            once: true,
          });
        }
      },
    });

    // グローバルナビ: ドロワー内クリックでは閉じず、クローズボタンだけは Micromodal に渡す
    const globalNav = document.getElementById('global-nav');
    const drawer = globalNav?.querySelector('.global-nav__container');
    drawer?.addEventListener('click', (e) => {
      const target = e.target as HTMLElement | null;
      if (target?.closest('[data-modal-close]')) {
        // 閉じるボタンのクリックは Micromodal 側に任せる
        return;
      }
      e.stopPropagation();
    });

    // リサイズ時にモーダルを即座に閉じる（アニメーション待ちで不具合が出るため）
    const closeModalOnResize = () => {
      const openModal = document.querySelector('.modal.is-open');
      if (openModal instanceof HTMLElement && openModal.id) {
        openModal.classList.remove('is-open', 'is-closing');
        openModal.setAttribute('aria-hidden', 'true');
        document.getElementById('header')?.classList.remove('is-closing');
        document.body.style.overflow = '';
      }
    };
    window.addEventListener('resize', closeModalOnResize);
  },
};